import { useTranslation } from 'react-i18next';
import { marked } from 'marked';
import { UAParser } from 'ua-parser-js';
import xss from 'xss';
import { BoundedContent, Box } from '@vp/swan';
import LaunchMyBusinessTools from '../../components/LaunchMyBusinessTools/LaunchMyBusinessTools';
import LogomakerAnywhere from '../../components/LogomakerAnywhere/LogomakerAnywhere';
import LogoProductTiles from '../../components/LogoProductTiles/LogoProductTiles';
import { useTrackOnPageLoad } from '../../utils/analytics';
import { logoInspirationRootUrl } from '../../utils/urls';
import Faq from './components/Faq/Faq';
import Hero from './components/Hero/Hero';
import HowItWorks from './components/HowItWorks/HowItWorks';

const CORE_PRODUCT_ID = 'PRD-WRFGWR7PP';

const LogomakerClassicPage = () => {
    const { t } = useTranslation();
    const { browser, os, device } = UAParser();

    useTrackOnPageLoad('Product Viewed', {
        label: 'Product page view',
        core_product_id: CORE_PRODUCT_ID,
        variant: '',
    });

    useTrackOnPageLoad('Homepage Device Details', {
        label: 'Homepage:Device Details',
        core_product_id: CORE_PRODUCT_ID,
        browser,
        os,
        deviceType: device.type ?? 'desktop',
    });

    return (
        <>
            <Hero />
            <BoundedContent padding={0}>
                <LogomakerAnywhere
                    title={t('Vista Logos > Logomaker Anywhere > Heading.value')}
                    description={
                        <div
                            dangerouslySetInnerHTML={{
                                __html: xss(
                                    marked.parse(
                                        t(
                                            'Vista Logos > Logomaker Anywhere > Description.value',
                                        ) as string,
                                    ) as string,
                                ),
                            }}
                        />
                    }
                    backgroundColor="standard"
                />
            </BoundedContent>
            <HowItWorks />
            <Faq />
            <BoundedContent overflow="hidden" bgc="warm-white">
                <Box marginY="between-sections">
                    <LogoProductTiles
                        title={t('Logomaker landing page > Other products.sectionHeader')}
                        description={
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: xss(
                                        t(
                                            'Logomaker landing page > Other products.sectionSubHeader',
                                            {
                                                logoInspirationRootLink: logoInspirationRootUrl(),
                                            },
                                        ) as string,
                                    ),
                                }}
                            />
                        }
                        showLogomaker={false}
                        trackingCategory="Design Services"
                    />
                </Box>
            </BoundedContent>
            <LaunchMyBusinessTools
                header={t('Vista Logos > Launch My Business Tools > Heading.value')}
                subheader={t(
                    'Vista Logos > Logomaker landing page > Launch My Business Tools > Description.value',
                )}
                businessTools={[
                    'businessNameGenerator',
                    'brandKit',
                    'wixWebsites',
                    'socialMediaTemplates',
                    'design',
                ]}
                trackingCategory="Design Services"
            />
        </>
    );
};

export default LogomakerClassicPage;
